/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
export const FETCH_CONTENTS_DETAILS_REQUEST = "FETCH_CONTENTS_DETAILS_REQUEST";
export const FETCH_CONTENTS_DETAILS_SUCCESS = "FETCH_CONTENTS_DETAILS_SUCCESS";
export const FETCH_CONTENTS_DETAILS_FAILURE = "FETCH_CONTENTS_DETAILS_FAILURE";

// Domain Approver Contents Actions
export const FETCH_DOMAIN_APPROVER_CONTENTS_REQUEST = "FETCH_DOMAIN_APPROVER_CONTENTS_REQUEST";
export const FETCH_DOMAIN_APPROVER_CONTENTS_SUCCESS = "FETCH_DOMAIN_APPROVER_CONTENTS_SUCCESS";
export const FETCH_DOMAIN_APPROVER_CONTENTS_FAILURE = "FETCH_DOMAIN_APPROVER_CONTENTS_FAILURE";
